<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="pb-2">
    <div [hidden]="isLoading" class="col-md-10 offset-md-1 animate__animated animate__fadeIn">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div [innerHTML]="'tkey;admin.manual_cdr_import.description' | escapeHtml"></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
      @if (jobIsCurrentlyRunning) {
        <div class="card border-primary text-center mb-3" data-automation="cdr-import-refreshing-card">
          <div class="card-body strong">
            <i class="{{ ziroIcons.SAVING }} pe-1"></i>
            <span [innerHTML]="'tkey;admin.manual_cdr_import.loading.text' | escapeHtml"></span>
          </div>
        </div>
      }

      <div [hidden]="jobIsCurrentlyRunning">
        <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
          <ziro-file-upload [fieldId]="'cdrTextFile'" class="d-block"></ziro-file-upload>
        </ziro-collapsible-section-card>
      </div>
    </div>
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
